import styled from 'styled-components';
import { variables } from 'components/theme';

export const PhoneInputWrapper = styled.div`
  height: 60px;
  .react-tel-input input[type='tel'] {
    width: 100%;
    border: 0.5px solid #707070;
    border-radius: 8px;
    box-shadow: none;
    padding-left: 58px;
    height: 42px;
    align-items: center;
    transition: all 0.1s ease-in-out;
  }

  .react-tel-input .flag-dropdown {
    width: 50px;
    border: 0.5px solid #707070;
    background-color: #f6f6f6;
    border-right: none;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .react-tel-input .selected-flag {
    width: 50px;
    background-color: transparent;
  }

  .react-tel-input .flag-dropdown.open-dropdown {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .react-tel-input .flag-dropdown.open-dropdown .selected-flag {
    background: transparent;
  }

  .react-tel-input .flag-dropdown:hover .selected-flag,
  .react-tel-input .flag-dropdown:focus .selected-flag {
    background-color: transparent;
  }

  .react-tel-input .country-list {
    width: 420px;
    ${variables.fonts.openSansSemiBold};
    font-size: 14px;
  }

  .react-tel-input .country-list .search-box {
    height: 20px;
    width: 80%;
  }
`;
